import React from "react"
import SnipcartButtonIndivItem from "../buttons/snipcartbuttonindivitem"
import SimpleAccordion from "../accordian"
import CollapseText from "../collapsetext.js"
import SlideShow from "../slideshow/slideshowProduct"
import RippleButton from "../buttons/ripplebutton.jsx"



const IndivItem = ({ product }) => {
  


  return (
    <section className="u-standard-section-margins product">
      <div className="product__left">
        <SlideShow photos={product.photos} />
        {/* <Slideshow photos={product.photos} /> */}
        {/* {product.photos.map((photo) => {
                return (
                  <Img fluid={photo.fluid} alt={photo.alt} key={photo.id} />
                )
            
              })} */}
      </div>

      <div className="product__right">
        <div className="product__header">
          <h1 className="product__title">{product.name}</h1>
          <p className="product__price">${product.price}</p>
        </div>

        <hr className="u-margin-top-medium product__line" />

        <div className="u-margin-top-medium product__description">
          <CollapseText description={product.description} />
        </div>

        <hr className="u-margin-top-medium product__line" />

        <div className="u-margin-top-small">
          <RippleButton>
            <SnipcartButtonIndivItem
              id={product.id}
              price={product.price}
              link={`shop/${product.slug}`}
              description={product.description}
              imagesrc={product.photos[0].fluid.src}
              name={product.name}
              buttonText="Add to Cart"
            />
          </RippleButton>
        </div>

        <hr className="u-margin-top-medium product__line" />

        <SimpleAccordion TransitionProps={{ unmountOnExit: true }} />

        <hr className="u-margin-top-medium product__line" />
      </div>
    </section>
  )
}

export default IndivItem
